import { Component, Input } from '@angular/core';
import template from './helpTip.html';

@Component({
  selector: 'help-tip',
  template
})
export class HelpTipComponent {
  @Input() helpText;
  @Input() id;
  @Input() allytmln;


  ngOnInit() {
    this.helpActive = false;
    this.clickY = -1;
  }

  toggleHelp(event) {
    this.helpActive = !this.helpActive;
    if (this.helpActive === true) {
      this.clickY = event.clientY;
    }
  }
}
